import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Stable per-browser device id so the Owner can see and revoke devices.
export const DEVICE_ID_KEY = "pramsia-device-id";

export function deviceId() {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

api.interceptors.request.use((config) => {
  config.headers["X-Device-Id"] = deviceId();
  return config;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const inr2 = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const shortDate = (v) => (v ? String(v).slice(0, 10) : "-");

/** Non-blocking failures (optional widgets, best-effort calls) are reported here only. */
export function logError(context, error) {
  if (process.env.NODE_ENV !== "production") {
    console.error(`[${context}]`, error);
  }
}

export function fileUrl(u) {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
}

export async function uploadFile(file, entity = "general", entityId = "") {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(
    `/files?entity=${encodeURIComponent(entity)}&entity_id=${encodeURIComponent(entityId)}`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}
